import React, { useContext } from 'react';
import SidebarToggleHandler from '../../../../../@coremat/CmtLayouts/Vertical/SidebarToggleHandler';
import Toolbar from '@material-ui/core/Toolbar';
import { Box, fade, IconButton, InputBase, Tooltip } from '@material-ui/core';
import { Link } from 'react-router-dom';
import LanguageSwitcher from '../LanguageSwitcher';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SearchIcon from '@material-ui/icons/Search';
import HomeIcon from '@material-ui/icons/Home';
import AppsMenu from './AppsMenu';
import Typography from '@material-ui/core/Typography';
import HeaderNotifications from './HeaderNotifications';
import HeaderMessages from './HeaderMessages';
import Hidden from '@material-ui/core/Hidden';
import Logo from '../Logo';
import SearchPopover from '../SearchPopover';
import RefreshIcon from '@material-ui/icons/Refresh';
import { useSelector } from 'react-redux';
import AppContext from '../../../contextProvider/AppContextProvider/AppContext';
import { styled } from '@material-ui/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

import { ReactComponent as FeedbackIcon } from '../../../../../icons/feedback.svg';
import { ReactComponent as HelpIcon } from '../../../../../icons/help.svg';

const StyledSvgIcon = styled(SvgIcon)(({ theme }) => ({
  // Define your CSS styles here
  stroke: theme.palette.header.font,
}));

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.header.font,
    width: '100%',
    paddingLeft: 16,
    paddingRight: 16,
    minHeight: 64,
    [theme.breakpoints.up('md')]: {
      minHeight: 72,
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: 24,
      paddingRight: 24,
    },
  },
  menuIcon: {
    //colose: 'white',
    stroke: theme.palette.header.font,
  },
  searchRoot: {
    position: 'relative',
    width: 260,
    [theme.breakpoints.up('md')]: {
      width: 350,
    },
    '& .MuiSvgIcon-root': {
      position: 'absolute',
      left: 18,
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 1,
    },
    '& .MuiInputBase-root': {
      width: '100%',
    },
    '& .MuiInputBase-input': {
      height: 48,
      borderRadius: 30,
      backgroundColor: fade(theme.palette.common.dark, 0.38),
      color: fade(theme.palette.common.white, 0.7),
      boxSizing: 'border-box',
      padding: '5px 15px 5px 50px',
      transition: 'all 0.3s ease',
      '&:focus': {
        backgroundColor: fade(theme.palette.common.dark, 0.58),
        color: fade(theme.palette.common.white, 0.7),
      },
    },
  },
  langRoot: {
    borderLeft: `solid 1px ${fade(theme.palette.common.dark, 0.15)}`,
    minHeight: 72,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 8,
    paddingRight: 8,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      minHeight: 64,
    },
  },

  iconBtn: {
    color: fade(theme.palette.header.font, 0.38),
    '&:hover, &:focus': {
      color: theme.palette.common.white,
    },
  },
}));

const Header = () => {
  const classes = useStyles();
  const { authUser } = useSelector(({ auth }) => auth);
  const { currentPage, setCurrentPage } = useContext(AppContext);
  var a = navigator.userAgent || navigator.vendor || window.opera;
  var mobile =
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
      a,
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      a.substr(0, 4),
    );
  if (window.innerWidth < 800) mobile = true;

  return (
    <Toolbar className={classes.root}>
      <SidebarToggleHandler edge="start" color="inherit" aria-label="menu" />
      {authUser != null && authUser.clouduser == 0 && <Logo ml={2} color="white" />}
      <Box flex={1}>
        {authUser != null && (authUser.clouduser == 1 || authUser.clouduser == 2) && <Typography>{currentPage}</Typography>}
      </Box>
      {/*
      <Hidden smDown>
        <Box pr={3} className={classes.searchRoot}>
          <InputBase placeholder={'Search here...'} inputProps={{ 'aria-label': 'search' }} />
          <SearchIcon />
        </Box>
      </Hidden>
          */}
      {authUser != null && authUser.masterAccount === 1 && (
        <Tooltip title="Select Property">
          <IconButton
            onClick={() => {
              localStorage.removeItem('selectedProperty');
              window.location.href = '/pages/selectproperty';
            }}>
            <HomeIcon className={classes.menuIcon} />
          </IconButton>
        </Tooltip>
      )}
      {mobile == false && authUser != null && authUser.clouduser == 0 && authUser.role == 10 && <AppsMenu />}
      {authUser != null && authUser.clouduser == 0 && authUser.role == 10 && (
        <Tooltip title="FeedBack">
          <IconButton component={Link} to="/pages/feedback" className={classes.menuIcon}>
            <FeedbackIcon color="white" className={classes.menuIcon} />
          </IconButton>
        </Tooltip>
      )}
      {mobile == false && authUser != null && authUser.clouduser == 0 && authUser.role == 10 && (
        <Tooltip title="Help">
          <IconButton component={Link} to="/pages/help">
            <HelpIcon className={classes.menuIcon} />
          </IconButton>
        </Tooltip>
      )}
      {authUser != null && authUser.clouduser != 3 && (
        <Box className={classes.langRoot}>
          <LanguageSwitcher />
        </Box>
      )}
      {authUser != null && (authUser.clouduser == 1 || authUser.clouduser == 2) && (
        <Tooltip title="Refresh">
          <IconButton
            onClick={() => {
              window.location.reload(false);
            }}>
            <RefreshIcon style={{ color: 'white' }} />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

export default Header;
